import React from "react";
import KeyValue from "../KeyValue";
import CustomButton from "../CustomButton";
import { EditPencil01, Trash } from "../../normalizer";

const UserAddress = (props) => {
  const {
    setEditing,
    first_name: firstName,
    last_name: lastName,
    phone,
    email,
    address1,
    city,
    address2,
    country = {},
    state = {},
    main_name: mainName,
    zip_code: zipCode,
    onRemove,
    isShowOnly,
    className
  } = props;

  const hasMainName = mainName !== "";

  return (
    <section className={`user-address flex flex-col ${className}`}>
      {!isShowOnly && hasMainName && (
        <h1 className="user-address-name">{mainName}</h1>
      )}
      {!isShowOnly && !hasMainName && (
        <h1 className="user-address-title">Morada</h1>
      )}
      <div className="user-address-container">
        <div className="row gl-profile__info-data gl-profile__info-block">
          <div className="user-address-field">
            <KeyValue 
              colSpan={3} 
              title="Morada" 
              value={`${address1}, ${address2}`}
              value2={`${city}, ${zipCode}`} 
              value3={`${country.name}`} 
              />
          </div>
          <div className="user-contacts-field">
            <KeyValue 
              colSpan={3} 
              title="Contactos" 
              value={`${firstName} ${lastName}`} 
              value2={email} 
              value3={phone}
              />
          </div>
          <div className="user-address-filler"></div>
        </div>
      </div>
      {isShowOnly ? null : (
        <div className="user-address-buttons">
          <CustomButton className="user-address-button" link small tight onClick={setEditing}>
            <EditPencil01
              className="user-address-button-icon"
              width={20}
              height={20}
            />
            Editar morada
          </CustomButton>
          <CustomButton className="user-address-button" alert link small tight onClick={onRemove}>
            <Trash
              className="user-address-button-icon"
              width={20}
              height={20}
            />
            Remover morada
          </CustomButton>
        </div>
      )}
    </section>
  );
};

export default UserAddress;
